export class PledgeDto {
  pledgeeId: number;
  pledgeeName: string;
  deedOfPledgeReceived: boolean;
  partiallyPledgedAmount: number;
  loanNumber: string;
}
